const initialState = "";

const userName = (state = initialState, action) => {
    switch(action.type) {
        case 'HANDLE_USER_NAME':
            state = action.payload.userName
            return state;

        default :
            return state;
    }
};

export default userName;